import React from 'react';
import { useState } from 'react';

import { Box } from '@rbilabs/universal-components';

import { CenteredRowContainer } from 'components/layout/centered-row-container';
import { CustomEventNames } from 'state/amplitude';

import { MinimalMenuReorderCard } from './minimal-menu-reorder-card';
import { MinimalMenuReorderDetailsDrawer } from './minimal-menu-reorder-details-drawer';
import { useLastMinimalOrderAvailableToReorder } from './use-last-minimal-order-available-to-reorder';

export const MinimalMenuReorderWidget = () => {
  const openDetailEventMessage = CustomEventNames.LAST_ORDER_DETAILS;
  const lastOrder = useLastMinimalOrderAvailableToReorder();
  const [isDetailsDrawerOpen, setIsDetailsDrawerOpen] = useState<boolean>(false);
  const toggleDetailsDrawer = () => setIsDetailsDrawerOpen(!isDetailsDrawerOpen);

  if (!lastOrder) {
    return null;
  }

  return (
    <CenteredRowContainer>
      {isDetailsDrawerOpen ? (
        <MinimalMenuReorderDetailsDrawer
          order={lastOrder}
          showDrawer={isDetailsDrawerOpen}
          toggleDetailsDrawer={toggleDetailsDrawer}
          openDetailEventMessage={openDetailEventMessage}
        />
      ) : (
        <Box padding="$4">
          <MinimalMenuReorderCard
            order={lastOrder}
            toggleDetailsDrawer={toggleDetailsDrawer}
            drawerIsOpen={isDetailsDrawerOpen}
          />
        </Box>
      )}
    </CenteredRowContainer>
  );
};
